import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchEftHistory = (queryParams, retailerId) => {
  const { url } = DepsService.rest.widgets.eftHistory;
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchEftExtensions = () => {
  const { url } = DepsService.rest.reports.eft.extensions;
  const queryParams = {};
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchRetailerEFTDetailDate = (retailerId) => {
  const { url } = DepsService.rest.reports.eft.date;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadEftInvoice = ({ extension, retailerId, invoiceWeekEndDate }) => {
  const { url } = DepsService.rest.reports.eft.downloadRetailerInvoice;
  const queryParams = {
    retailerId,
    reportDate: invoiceWeekEndDate,
    'transformation-type': extension,
  };
  const urlParams = {};

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/eft-history.api.js